var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DatasetAsImage',{attrs:{"path":_vm.args.path,"history_dataset_id":_vm.args.history_dataset_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }